import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { 
  FaUsers, FaGraduationCap, FaUserTie, 
  FaChalkboardTeacher, FaNetworkWired, 
  FaLaptopCode, FaUserGraduate, FaUserCheck
} from 'react-icons/fa';

const About = () => {
  // Team members data from the project proposal
  const teamMembers = [
    {
      name: 'BESONG WISDOM BESONG',
      role: 'Team Leader',
      specialty: 'Software Development',
      email: 'wisdom.besong@student.ubuea.cm',
      icon: <FaLaptopCode />,
      gender: 'male'
    },
    {
      name: 'ASONG BEQUIKEH PHILO-BLENCH',
      role: 'Team Member',
      specialty: 'Networking',
      email: 'philo.asong@student.ubuea.cm',
      icon: <FaNetworkWired />,
      gender: 'female'
    },
    {
      name: 'BITJOKA YVES JEREMIE',
      role: 'Team Member',
      specialty: 'Software Development',
      email: 'yves.bitjoka@student.ubuea.cm',
      icon: <FaLaptopCode />,
      gender: 'male'
    },
    {
      name: 'BENNETT NDONGTSSOP TSAMO',
      role: 'Team Member',
      specialty: 'Networking',
      email: 'bennett.tsamo@student.ubuea.cm',
      icon: <FaNetworkWired />,
      gender: 'male'
    },
    {
      name: 'FUAMBU RADON NGAIWI',
      role: 'Team Member',
      specialty: 'Networking',
      email: 'radon.fuambu@student.ubuea.cm',
      icon: <FaNetworkWired />,
      gender: 'male'
    }
  ];

  const supervisor = {
    name: 'MR KOMETA',
    role: 'Course Instructor & Project Supervisor',
    department: 'College of Technology',
    course: 'CEC315 - Introduction to Cloud Computing',
    email: 'kometa@ubuea.cm',
    icon: <FaChalkboardTeacher />
  };

  const projectInfo = {
    title: 'Cloud-Based Tutor Connect Platform',
    description: 'A cloud computing project designed to connect students with qualified tutors across Cameroon, addressing educational accessibility challenges through technology.',
    course: 'CEC315 - Introduction to Cloud Computing',
    institution: 'University of Buea',
    group: 'Group 9'
  };

  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1>About Our Project</h1>
            <p className="hero-subtitle">
              {projectInfo.title}
            </p>
            <p className="hero-description">
              {projectInfo.description} This project is developed as part of {projectInfo.course} at {projectInfo.institution}.
            </p>
            <div className="project-meta">
              <span className="meta-badge">{projectInfo.institution}</span>
              <span className="meta-badge">{projectInfo.course}</span>
              <span className="meta-badge">{projectInfo.group}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Project Overview */}
      <section className="project-overview">
        <div className="container">
          <div className="section-header">
            <h2>Project Overview</h2>
            <p>Bridging educational gaps through cloud technology</p>
          </div>
          
          <div className="overview-content">
            <div className="overview-card">
              <div className="overview-icon">
                <FaGraduationCap />
              </div>
              <h3>The Challenge</h3>
              <p>
                In Cameroon, students face difficulties finding qualified tutors due to informal 
                networks and lack of organized platforms. Tutors struggle to reach potential students 
                beyond their immediate surroundings.
              </p>
            </div>
            
            <div className="overview-card">
              <div className="overview-icon">
                <FaChalkboardTeacher />
              </div>
              <h3>Our Solution</h3>
              <p>
                A cloud-based web platform that connects students with verified tutors based on 
                subject specialization, academic level, and geographic location, making the 
                process transparent, efficient, and accessible.
              </p>
            </div>
            
            <div className="overview-card">
              <div className="overview-icon">
                <FaUsers />
              </div>
              <h3>Cloud Benefits</h3>
              <p>
                By leveraging cloud computing, our platform ensures scalability, reliability, 
                and security while being accessible from anywhere in Cameroon with an internet 
                connection.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Members Section */}
      <section className="team-section">
        <div className="container">
          <div className="section-header">
            <h2>Project Team Members</h2>
            <p>Meet the dedicated students behind this cloud computing project</p>
          </div>
          
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div key={index} className="team-card">
                <div className={`team-avatar ${member.gender}`}>
                  {member.icon}
                </div>
                <h3>{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-specialty">{member.specialty}</p>
                <div className="team-contact">
                  <a href={`mailto:${member.email}`} className="email-link">
                    {member.email}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Supervisor Section */}
      <section className="supervisor-section">
        <div className="container">
          <div className="section-header">
            <h2>Project Supervision</h2>
            <p>Guided by experienced faculty</p>
          </div>
          
          <div className="supervisor-card">
            <div className="supervisor-avatar">
              {supervisor.icon}
            </div>
            <div className="supervisor-info">
              <h3>{supervisor.name}</h3>
              <p className="supervisor-role">{supervisor.role}</p>
              <p className="supervisor-dept">{supervisor.department}</p>
              <p className="supervisor-course">{supervisor.course}</p>
              <div className="supervisor-contact">
                <a href={`mailto:${supervisor.email}`} className="email-link">
                  {supervisor.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Purpose */}
      <section className="purpose-section">
        <div className="container">
          <div className="purpose-content">
            <div className="purpose-text">
              <h2>Why This Project Matters</h2>
              <p>
                This project demonstrates practical application of cloud computing principles 
                to solve real-world problems in education. By creating a platform that can 
                scale to serve students across Cameroon, we showcase how technology can 
                transform traditional educational challenges into opportunities for growth 
                and accessibility.
              </p>
              <p>
                As a cloud computing course project, it incorporates key concepts including 
                cloud architecture, scalability, security, and serverless computing.
              </p>
            </div>
            <div className="purpose-icon">
              <FaUserGraduate />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default About;